import Api from "./Api";

export default {

    /**
    * Get Top Users
    */
    async getAll(){
      return Api.get("/kings");
    },

};